
<div class="white-bg no-padding no-margin">

<mat-card>
  <div style="text-align: center; margin-top: 1%;">
    <span class="title-header">{{'Setup Training Questions' | translate | async}} </span>
  </div>

  <span style="font-size: larger; "><b>{{'Select Training' | translate | async}}</b></span>
    
  
     <mat-select placeholder="Select Training"   style="width: 345px;     margin-left: 6%;"  [(ngModel)]="TrainingId" >
      <mat-optgroup *ngFor="let group of TrainingCategories" [label]="group.Name">
        <mat-option *ngFor="let training of group.Trainings" [value]="training.TrainingId" (click)="TrainingSelect()">
          {{training.TrainingName  | translate | async}}
        </mat-option>
      </mat-optgroup>
    </mat-select> 
   

    <ng-container *ngIf="TrainingId>0">
      <ng-container *ngFor="let fs of SubTrainings">
          <div style="display: flex;margin-left: 10%;    margin-top: 2%;" >
           
            <span style="font-size: larger; "><b><u>{{fs.TrainigSubName  | translate | async}}</u></b></span>
            <!-- <i  class="material-icons sc-icon" style="align-self: center;cursor: pointer;"  (click)="OpenEditSubTraining(fs.TrainigSubId,false,fs.TrainigSubName)">edit</i> -->
              
           </div>
        
           



           <div>
            <table id="fs.TrainigSubId" style="width: 100%;" class="table table--full-width table--striped table--hover">
                <thead>
                    <tr>
                        <th></th>
                        <th style="text-align: inherit;">{{'Question' | translate | async}}</th>
                        <th style="text-align: inherit;">{{'Slide' | translate | async}}</th>
                        <th style="text-align: inherit;">{{'Type'  | translate | async}}</th>
                        <th style="text-align: inherit;"></th>
                        <th style="text-align: inherit;"></th>
        
                    </tr>
                </thead>
                <tbody id="tbody-questions">
        
                  <ng-container *ngIf="TrainingQuestions!=null">
                    <ng-container *ngFor="let f of TrainingQuestions">
        
                      <tr *ngIf="f.SubSectionId == fs.TrainigSubId">
                        <td>
                            <div style="float: right;cursor: pointer;">
                              
                                    <i *ngIf="f.Active" style="color: green;" class="material-icons sc-icon" (click)="toggleQuestion(f.QuestionId, false)">done</i>
                               
                                    <i *ngIf="!f.Active"style="color: red;" class="material-icons sc-icon" (click)="toggleQuestion(f.QuestionId, true)">cancel</i>
                                
                            </div>
                        </td>
                        <td style="width: 40%;">
                            <div style="display:flex;flex-direction:row;">
                                <div class="sc-item2" title="f.QDescription">{{f.QuestionName  | translate | async}} </div>
                            </div>
                        </td>
                        <td>
                            <div class="sc-item2" title="f.SlideName">{{f.SlideName  | translate | async}}</div>
                          
                        </td>
                        <td>
                          <div class="sc-item2" title="f.QuestionTypeName">{{f.QuestionTypeName  | translate | async}}</div>
                        
                      </td>
      
                      
                        <td>
                            <div>
                                <i class="material-icons sc-icon" (click)="OpenEditQuestion(f.SubSectionId,f.QuestionId)" style="cursor: pointer;">edit</i>
                            </div>
                        </td>
                        
                       
                      
                        <ng-container *ngIf="f.Order == 0 && fs.QuestionCount != 1">
                          <td>
                            <span style="max-width: 30em; text-overflow: ellipsis; overflow: hidden; white-space: nowrap;">
                                <i style="font-size:30px;cursor: pointer;" class="material-icons sc-icon" (click)="OrderDown_Q(f.Order,f.SubSectionId)">arrow_drop_down</i>
                            </span>
                          </td>
                        </ng-container>
                            
                        <ng-container *ngIf="fs.QuestionCount != 1 && f.Order != 0">
                          <ng-container *ngIf="f.Order == fs.QuestionCount - 1">
                            <td>
                              <span id="cell_6" style="max-width: 30em; text-overflow: ellipsis; overflow: hidden; white-space: nowrap;">
                               
                              </span>
                          </td>
                          <td>
                              <span id="cell_6" style="max-width: 30em; text-overflow: ellipsis; overflow: hidden; white-space: nowrap;">
                                <i style="font-size:30px;cursor: pointer;" class="material-icons sc-icon" (click)="OrderUP_Q(f.Order,f.SubSectionId)">arrow_drop_up</i>
                              </span>
                          </td>
      
                          </ng-container>
      
                          <ng-container *ngIf="f.Order != fs.QuestionCount - 1">
                            <td>
                              <span id="cell_6" style="max-width: 30em; text-overflow: ellipsis; overflow: hidden; white-space: nowrap;">
                                <i style="font-size:30px;cursor: pointer;" class="material-icons sc-icon" (click)="OrderDown_Q(f.Order,f.SubSectionId)">arrow_drop_down</i>
                              </span>
                          </td>
                          <td>
                              <span style="max-width: 30em; text-overflow: ellipsis; overflow: hidden; white-space: nowrap;">
                                <i style="font-size:30px;cursor: pointer;" class="material-icons sc-icon" (click)="OrderUP_Q(f.Order,f.SubSectionId)">arrow_drop_up</i>
                              </span>
                          </td>
                            </ng-container>
                        </ng-container>
                       
                            
                    </tr>
                    </ng-container>
                  </ng-container>
                  
                </tbody>
            </table>
        
        </div>

           <div style="width: 100%;   display: flex;flex-direction: row;justify-content: flex-end;">
            <a class="button button--primary" style="margin-bottom: 16px;margin-left: 15%; " (click)="OpenAddQuestion(fs.TrainigSubId)" >
              <span class="button__text">{{'Add Question' | translate | async}}</span></a>
          </div>
        
        
      </ng-container>
    </ng-container>
  

  
</mat-card>
</div>